var EMPTY_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
var CDN_PRISMIC_DEPRECATED = 'https://maisonsdumonde.cdn.prismic.io/';
var CDN_PRISMIC = 'https://images.prismic.io/maisonsdumonde/';
var CDN_MDM = 'https://cdn.maisonsdumonde.com';
var MEDIA_PATH = 'https://medias.maisonsdumonde.com';
export { EMPTY_PIXEL, CDN_PRISMIC_DEPRECATED, CDN_PRISMIC, CDN_MDM, MEDIA_PATH };
export var IMAGE_SIZES = {
  THUMBNAIL: 100,
  XS: 200,
  S: 350,
  M: 500,
  L: 1000,
  XL: 1500
};
export var VIDEO_SIZES = {
  THUMBNAIL: 100,
  XSMALL: 200,
  SMALL: 350,
  MEDIUM: 500,
  LARGE: 1000,
  XLARGE: 1440
};